
export interface IPublicTypeEditorGetOptions {
  forceNew?: boolean;
  sourceCls?: new (...args: any[]) => any;
}
